
import { useState } from 'react';

export default function HomePage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMenuOpen(false);
    }
  };

  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-amber-50">
      {/* ナビゲーション */}
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center">
                <i className="ri-leaf-fill text-white text-xl"></i>
              </div>
              <div>
                <div className="text-2xl font-bold text-orange-700">めーぷる</div>
                <div className="text-xs text-gray-600">就労継続支援B型事業所</div>
              </div>
            </div>
            
            <div className="hidden md:flex space-x-6">
              <button onClick={() => scrollToSection('concept')} className="text-gray-700 hover:text-orange-600 transition-colors">理念</button>
              <button onClick={() => scrollToSection('features')} className="text-gray-700 hover:text-orange-600 transition-colors">特徴</button>
              <button onClick={() => scrollToSection('work')} className="text-gray-700 hover:text-orange-600 transition-colors">作業内容</button>
              <button onClick={() => scrollToSection('voices')} className="text-gray-700 hover:text-orange-600 transition-colors">利用者の声</button>
              <button onClick={() => scrollToSection('staff')} className="text-gray-700 hover:text-orange-600 transition-colors">スタッフ</button>
              <button onClick={() => scrollToSection('usage')} className="text-gray-700 hover:text-orange-600 transition-colors">利用について</button>
              <button onClick={() => scrollToSection('faq')} className="text-gray-700 hover:text-orange-600 transition-colors">FAQ</button>
              <button onClick={() => scrollToSection('contact')} className="text-gray-700 hover:text-orange-600 transition-colors">お問い合わせ</button>
            </div>

            <button 
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-orange-600 cursor-pointer"
            >
              <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>
        </div>

        {isMenuOpen && (
          <div className="md:hidden bg-white border-t">
            <div className="px-4 py-3 space-y-3">
              <button onClick={() => scrollToSection('concept')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">理念</button>
              <button onClick={() => scrollToSection('features')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">特徴</button>
              <button onClick={() => scrollToSection('work')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">作業内容</button>
              <button onClick={() => scrollToSection('voices')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">利用者の声</button>
              <button onClick={() => scrollToSection('staff')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">スタッフ</button>
              <button onClick={() => scrollToSection('usage')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">利用について</button>
              <button onClick={() => scrollToSection('faq')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">FAQ</button>
              <button onClick={() => scrollToSection('contact')} className="block w-full text-left py-2 text-gray-700 hover:text-orange-600">お問い合わせ</button>
            </div>
          </div>
        )}
      </nav>

      {/* ヒーローセクション */}
      <section className="relative pt-16 min-h-screen flex items-center">
        <div className="absolute inset-0">
          <img 
            src="https://static.readdy.ai/image/883385092dfd56f4edce37e051526201/db175e439f855149278d32911f4e0ab9.jpeg" 
            alt="めーぷる店舗外観" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-orange-900/40 via-amber-900/30 to-white"></div>
        </div>
        
        <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <div className="inline-block bg-amber-400 text-orange-900 px-6 py-2 rounded-full text-sm font-bold mb-6 shadow-lg">
              令和7年オープン ✨ 小平市の新しい事業所
            </div>
            
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-4 drop-shadow-lg">
              めーぷる
            </h1>
            
            <div className="text-xl md:text-2xl text-white font-medium mb-8 drop-shadow-md">
              就労継続支援B型事業所
            </div>
            
            <p className="text-2xl md:text-4xl text-white font-bold mb-8 leading-relaxed drop-shadow-lg">
              『通う』『続ける』ことからスタート。<br />
              できることを。自分のペースで。
            </p>

            <div className="inline-block bg-white/95 backdrop-blur-sm px-8 py-4 rounded-2xl shadow-xl mb-8">
              <p className="text-orange-600 font-bold text-lg mb-2">
                <i className="ri-user-add-line mr-2"></i>利用者募集中
              </p>
              <p className="text-gray-700 text-sm">
                週1日から、午前のみ・午後のみでもOK
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a 
                href="https://forms.gle/qAGBGUHxTvaTkeAW8"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-amber-500 hover:bg-amber-600 text-white px-8 py-4 rounded-full text-lg font-bold shadow-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer inline-block"
              >
                <i className="ri-calendar-check-line mr-2"></i>見学のお申し込み
              </a>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-white hover:bg-gray-50 text-orange-700 px-8 py-4 rounded-full text-lg font-bold shadow-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>お問い合わせ
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* コンセプト・理念 */}
      <section id="concept" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-heart-line text-amber-500 mr-3"></i>
              コンセプト・理念
            </h2>
            <p className="text-gray-600 text-lg">一人ひとりのペースを大切に</p>
          </div>

          <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 md:p-12 rounded-3xl shadow-lg mb-12">
            <div className="max-w-4xl mx-auto">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">
                「何ができるか」より「続けられるか」を大切に
              </h3>
              <p className="text-gray-700 leading-relaxed text-lg mb-6">
                めーぷるでは、就労に不安を抱えている方が、まず「通う」「続ける」ことから始められるよう支援しています。
                一人ひとりの体調や状況に合わせて、無理なく取り組める作業を一緒に見つけていきます。
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                生活リズムを整えること、社会とのつながりを持つこと、そして自分のペースで成長していくこと。
                それぞれの目標は、スタッフと相談しながら一緒に決めていきます。
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-user-smile-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">自分にできること</h3>
              <p className="text-gray-700 leading-relaxed text-center">
                一人ひとりの「できること」を大切にし、無理なく取り組める作業を一緒に見つけていきます。
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-calendar-check-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">続けること</h3>
              <p className="text-gray-700 leading-relaxed text-center">
                「続ける」ことを第一に、体調や状況に合わせて柔軟に対応します。
              </p>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-md hover:shadow-xl transition-shadow">
              <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className="ri-discuss-line text-white text-3xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4 text-center">相談して決める</h3>
              <p className="text-gray-700 leading-relaxed text-center">
                それぞれの目標は、スタッフと相談しながら一緒に決めていきます。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 事業所の特徴 */}
      <section id="features" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-star-line text-amber-500 mr-3"></i>
              めーぷるの特徴
            </h2>
            <p className="text-gray-600 text-lg">商店街の中で、地域とつながる</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-hand-heart-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">寄り添った支援</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                就労に不安を抱いている方に寄り添い、一人ひとりのペースで無理なく支援を行います。
              </p>
              <p className="text-sm text-gray-600">
                体調や気分に合わせて作業内容や時間を調整できます。
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-store-2-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">商店街の駄菓子屋</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                商店街の中に駄菓子屋の店舗を持ち、地域の人々と触れ合える機会があります。
              </p>
              <p className="text-sm text-gray-600">
                お客様との会話を通じて、社会とのつながりを実感できます。
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-contrast-drop-2-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">めだかの飼育</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                めだかの飼育を通じて、生き物を育てる体験ができます。水槽管理や繁殖にも携われます。
              </p>
              <p className="text-sm text-gray-600">
                120cm水槽で様々な種類のめだかを育てています。
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-team-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">地域との交流</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                めだかすくいなどの行事を通じて、子どもや地域住民との自然な交流があります。
              </p>
              <p className="text-sm text-gray-600">
                地域イベントへの参加で、社会参加の機会を提供します。
              </p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="w-20 h-20 bg-gradient-to-br from-amber-400 to-orange-500 rounded-2xl flex items-center justify-center mb-6">
                <i className="ri-heart-pulse-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">看護師の定期訪問</h3>
              <p className="text-gray-700 leading-relaxed mb-4">
                定期的に看護師が訪問し、体調や生活リズム、服薬などの相談ができます。
              </p>
              <p className="text-sm text-gray-600">
                月2回の訪問で、健康面のサポートを行います。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 商店街の雰囲気 */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl overflow-hidden shadow-xl">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="h-80 md:h-auto">
                <img 
                  src="https://static.readdy.ai/image/883385092dfd56f4edce37e051526201/8cafcefb9c02c55b96b6fac5bdae6fb2.jpeg" 
                  alt="商店街に面した店舗" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8 md:p-12 flex items-center">
                <div>
                  <div className="w-16 h-16 bg-amber-400 rounded-2xl flex items-center justify-center mb-6">
                    <i className="ri-community-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">商店街の中で地域とつながる</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    小平市の商店街に面した店舗で、地域の方々と自然に触れ合える環境です。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    通りを行き交う人々との挨拶や、お客様との会話を通じて、社会とのつながりを感じながら働くことができます。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 店内の様子 */}
      <section className="py-12 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-3xl overflow-hidden shadow-xl">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="h-80 md:h-auto">
                <img 
                  src="https://static.readdy.ai/image/883385092dfd56f4edce37e051526201/788d4387dc5a7c4403081d266ba8fe67.jpeg" 
                  alt="めーぷる店内の様子" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8 md:p-12 flex items-center">
                <div>
                  <div className="w-16 h-16 bg-amber-400 rounded-2xl flex items-center justify-center mb-6">
                    <i className="ri-store-3-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-3xl font-bold text-gray-900 mb-4">温かい店内の雰囲気</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    カラフルな駄菓子が並ぶ店内には、めだかの水槽もあります。商店街の中で、地域の方々と自然に触れ合える温かい空間です。
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    一人ひとりが自分のペースで作業できる、落ち着いた環境を大切にしています。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* さまざまな働き方 */}
      <section id="work" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-briefcase-line text-amber-500 mr-3"></i>
              さまざまな働き方
            </h2>
            <p className="text-gray-600 text-lg">興味・得意・その日の調子に合わせて選べます</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/883385092dfd56f4edce37e051526201/634330d061d6a7a1eb5386c12586dd69.jpeg" 
                  alt="めだかの飼育" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">めだかの飼育</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  めだかの飼育、繁殖、水槽管理など、生き物のお世話を通じて責任感を育みます。
                </p>
                <p className="text-sm text-gray-600">
                  <i className="ri-check-line text-amber-500 mr-1"></i>
                  生き物を育てる喜びを実感できます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-pink-50 to-rose-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://public.readdy.ai/ai/img_res/72b2d6dc814d1b31a247d9eff21b588f.jpg" 
                  alt="駄菓子の販売" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">駄菓子の販売</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  駄菓子の品出しや接客・販売、袋詰めなど、お客様と触れ合う楽しい作業です。
                </p>
                <p className="text-sm text-gray-600">
                  <i className="ri-check-line text-amber-500 mr-1"></i>
                  接客スキルやコミュニケーション力が身につきます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-indigo-50 to-violet-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Japanese%20person%20working%20comfortably%20on%20laptop%20computer%20doing%20data%20entry%20and%20inventory%20management%20in%20a%20cozy%20small%20office%20space%20with%20wooden%20desk%2C%20person%20sitting%20at%20organized%20workspace%20with%20papers%20and%20supplies%2C%20shelves%20with%20products%20in%20background%2C%20natural%20window%20light%20creating%20warm%20atmosphere%2C%20productive%20and%20calm%20work%20environment%2C%20illustration%20style%20with%20soft%20warm%20tones&width=400&height=300&seq=pc002&orientation=landscape" 
                  alt="パソコン作業" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">パソコン作業</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  商品の在庫管理やデータ入力など、パソコンを使った作業も選べます。
                </p>
                <p className="text-sm text-gray-600">
                  <i className="ri-check-line text-amber-500 mr-1"></i>
                  基本的なPC操作スキルが身につきます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Japanese%20people%20decorating%20a%20small%20cozy%20shop%20interior%20with%20seasonal%20Christmas%20and%20Valentine%20decorations%2C%20hanging%20colorful%20ornaments%20garlands%20and%20festive%20displays%2C%20cheerful%20diverse%20team%20of%20adults%20working%20together%20on%20creative%20store%20decoration%2C%20festive%20warm%20atmosphere%2C%20natural%20lighting%2C%20illustration%20art%20style%20with%20bright%20cheerful%20colors%2C%20collaborative%20creative%20work%20scene&width=400&height=300&seq=deco002&orientation=landscape" 
                  alt="店内装飾" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">季節の装飾</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  クリスマス、バレンタインなど季節に合わせた店内装飾で創造性を発揮できます。
                </p>
                <p className="text-sm text-gray-600">
                  <i className="ri-check-line text-amber-500 mr-1"></i>
                  創造力や表現力を育てます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-emerald-50 to-teal-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Japanese%20person%20cleaning%20and%20organizing%20a%20small%20cozy%20candy%20shop%20interior%20with%20wooden%20shelves%2C%20sweeping%20floor%20and%20wiping%20surfaces%20with%20care%2C%20person%20wearing%20comfortable%20apron%20doing%20simple%20cleaning%20tasks%2C%20neat%20and%20tidy%20store%20environment%20with%20products%20on%20shelves%2C%20natural%20daylight%20through%20windows%2C%20illustration%20art%20style%20with%20soft%20pastel%20colors%2C%20peaceful%20calm%20work%20atmosphere&width=400&height=300&seq=clean002&orientation=landscape" 
                  alt="店内清掃" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-3">店内清掃</h3>
                <p className="text-gray-700 leading-relaxed mb-3">
                  まずは簡単な清掃作業からスタート。基本的な作業から始められます。
                </p>
                <p className="text-sm text-gray-600">
                  <i className="ri-check-line text-amber-500 mr-1"></i>
                  基本的な作業習慣が身につきます
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1 flex items-center justify-center p-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-amber-400 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <i className="ri-more-line text-white text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">その他の作業</h3>
                <p className="text-gray-700 leading-relaxed">
                  あなたの興味や得意に合わせて、様々な作業をご用意しています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 利用者の声 */}
      <section id="voices" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-chat-smile-3-line text-amber-500 mr-3"></i>
              利用者・ご家族の声
            </h2>
            <p className="text-gray-600 text-lg">実際に利用されている方々の声をご紹介します</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-md">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-smile-line text-white text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900">Aさん（20代）</p>
                  <p className="text-sm text-gray-600">利用歴：3ヶ月</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                「最初は週1日から始めました。スタッフの方が優しく、自分のペースで続けられています。めだかのお世話が楽しくて、今では週3日通っています。」
              </p>
              <div className="flex items-center text-amber-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-md">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-heart-line text-white text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900">Bさんのご家族</p>
                  <p className="text-sm text-gray-600">利用歴：6ヶ月</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                「家では引きこもりがちでしたが、めーぷるに通い始めてから生活リズムが整ってきました。駄菓子屋での接客を通じて、少しずつ自信がついてきたようです。」
              </p>
              <div className="flex items-center text-amber-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 p-8 rounded-2xl shadow-md">
              <div className="flex items-center mb-6">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-user-smile-line text-white text-3xl"></i>
                </div>
                <div>
                  <p className="font-bold text-gray-900">Cさん（30代）</p>
                  <p className="text-sm text-gray-600">利用歴：1年</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed mb-4">
                「商店街の中にあるので、地域の方々と自然に交流できるのが良いです。看護師さんが定期的に来てくれるので、体調面でも安心して通えています。」
              </p>
              <div className="flex items-center text-amber-500">
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
                <i className="ri-star-fill"></i>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* スタッフ紹介 */}
      <section id="staff" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-team-line text-amber-500 mr-3"></i>
              スタッフ紹介
            </h2>
            <p className="text-gray-600 text-lg">経験豊富なスタッフが、あなたをサポートします</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div className="bg-white p-6 rounded-2xl shadow-md text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-star-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">管理者</h3>
              <p className="text-gray-600 text-sm mb-4">福祉業界経験15年</p>
              <p className="text-gray-700 text-sm leading-relaxed">
                一人ひとりに寄り添った支援を心がけています。
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-md text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-heart-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">サービス管理責任者</h3>
              <p className="text-gray-600 text-sm mb-4">福祉業界経験10年</p>
              <p className="text-gray-700 text-sm leading-relaxed">
                個別支援計画の作成と、きめ細やかなサポートを行います。
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-md text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-nurse-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">看護師</h3>
              <p className="text-gray-600 text-sm mb-4">看護師経験20年</p>
              <p className="text-gray-700 text-sm leading-relaxed">
                月2回の訪問で、健康面のサポートを行います。
              </p>
            </div>

            <div className="bg-white p-6 rounded-2xl shadow-md text-center">
              <div className="w-24 h-24 bg-gradient-to-br from-amber-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-smile-line text-white text-4xl"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">支援スタッフ</h3>
              <p className="text-gray-600 text-sm mb-4">複数名在籍</p>
              <p className="text-gray-700 text-sm leading-relaxed">
                日々の作業や生活面でのサポートを行います。
              </p>
            </div>
          </div>

          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg">
            <div className="max-w-4xl mx-auto text-center">
              <div className="w-20 h-20 bg-amber-400 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-heart-3-line text-white text-4xl"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-6">スタッフからのメッセージ</h3>
              <p className="text-gray-700 leading-relaxed text-lg mb-6">
                めーぷるでは、利用者の皆さんが「通う」「続ける」ことを第一に考え、一人ひとりのペースに合わせた支援を行っています。
              </p>
              <p className="text-gray-700 leading-relaxed text-lg">
                「何ができるか」より「続けられるか」を大切に、スタッフ一同、温かくサポートさせていただきます。
                まずはお気軽に見学にお越しください。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 利用について */}
      <section id="usage" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-information-line text-amber-500 mr-3"></i>
              利用について
            </h2>
            <p className="text-gray-600 text-lg">柔軟な利用スタイルで、無理なく続けられます</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-white p-8 rounded-2xl shadow-md">
              <div className="flex items-start mb-6">
                <div className="w-12 h-12 bg-amber-400 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-calendar-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">利用日数・時間</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>週1日から利用可能</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>午前のみ・午後のみの通所もOK</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>利用時間：9:00〜16:00（相談可）</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>状況に応じて日数や時間を調整できます</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="bg-orange-50 p-4 rounded-xl">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <i className="ri-heart-line text-amber-500 mr-2"></i>
                  一人ひとりのステップを大切にし、利用日数や作業量を無理に増やさない方針です。
                </p>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md">
              <div className="flex items-start mb-6">
                <div className="w-12 h-12 bg-amber-400 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-restaurant-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">昼食について</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>手作り弁当の提供あり</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>1食600円</span>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-amber-400 rounded-xl flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-car-line text-white text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">送迎について</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>送迎サービスあり</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-line text-amber-500 mr-2 mt-1"></i>
                      <span>送迎エリアはお問い合わせください</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* 利用までの流れ */}
          <div className="bg-white p-8 md:p-12 rounded-3xl shadow-lg mb-12">
            <h3 className="text-3xl font-bold text-gray-900 mb-8 text-center">
              <i className="ri-route-line text-amber-500 mr-3"></i>
              利用までの流れ
            </h3>
            <div className="grid md:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-2xl font-bold">1</span>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">お問い合わせ</h4>
                <p className="text-sm text-gray-600">電話またはフォームからお気軽にご連絡ください</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-2xl font-bold">2</span>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">見学・相談</h4>
                <p className="text-sm text-gray-600">施設の雰囲気を実際に見ていただきます</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-2xl font-bold">3</span>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">体験利用</h4>
                <p className="text-sm text-gray-600">実際に作業を体験していただけます</p>
              </div>
              <div className="text-center">
                <div className="w-16 h-16 bg-amber-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <span className="text-white text-2xl font-bold">4</span>
                </div>
                <h4 className="font-bold text-gray-900 mb-2">利用開始</h4>
                <p className="text-sm text-gray-600">ご自身のペースで通所を開始します</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-amber-400 to-orange-500 p-8 md:p-12 rounded-3xl shadow-xl text-white text-center">
            <div className="w-20 h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-eye-line text-white text-4xl"></i>
            </div>
            <h3 className="text-3xl font-bold mb-4">見学・相談について</h3>
            <p className="text-xl mb-6 leading-relaxed">
              見学は平日随時受付中（要予約）<br />
              利用を前提としない見学や相談のみも大歓迎です
            </p>
            <div className="bg-white/20 backdrop-blur-sm p-6 rounded-2xl inline-block mb-6">
              <p className="text-2xl font-bold">
                まずは見学やご相談から、<br className="md:hidden" />お気軽にお問い合わせください
              </p>
            </div>
            <a 
              href="https://forms.gle/qAGBGUHxTvaTkeAW8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-white text-orange-600 px-8 py-4 rounded-full text-lg font-bold shadow-lg transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line mr-2"></i>見学予約フォームはこちら
            </a>
          </div>
        </div>
      </section>

      {/* 送迎イメージ */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-md">
            <div className="grid md:grid-cols-2 gap-0">
              <div className="h-64 md:h-auto">
                <img 
                  src="https://readdy.ai/api/search-image?query=Friendly%20Japanese%20driver%20in%20casual%20work%20uniform%20helping%20passenger%20into%20a%20clean%20white%20van%20for%20welfare%20transportation%20service%20in%20Japan%2C%20warm%20smile%20and%20caring%20gesture%2C%20safe%20and%20comfortable%20vehicle%20interior%20visible%2C%20daytime%20natural%20lighting%2C%20illustration%20art%20style%20with%20soft%20warm%20colors%2C%20trustworthy%20and%20welcoming%20atmosphere%2C%20Japanese%20setting&width=500&height=400&seq=送迎002&orientation=landscape" 
                  alt="送迎サービス" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-8 flex items-center">
                <div>
                  <div className="w-16 h-16 bg-amber-400 rounded-2xl flex items-center justify-center mb-4">
                    <i className="ri-car-line text-white text-3xl"></i>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4">安心の送迎サービス</h3>
                  <p className="text-gray-700 leading-relaxed mb-4">
                    通所が難しい方のために、送迎サービスをご用意しています。安全運転で、ご自宅から事業所まで送迎いたします。
                  </p>
                  <p className="text-sm text-gray-600">
                    ※送迎エリアについては、お気軽にお問い合わせください
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-question-answer-line text-amber-500 mr-3"></i>
              よくある質問
            </h2>
            <p className="text-gray-600 text-lg">皆様からよくいただく質問にお答えします</p>
          </div>

          <div className="space-y-4">
            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(0)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">利用するにはどうすればいいですか？</span>
                <i className={`ri-arrow-${openFaq === 0 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 0 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  まずはお電話またはお問い合わせフォームからご連絡ください。見学や相談の日程を調整させていただきます。その後、体験利用を経て、正式な利用開始となります。
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(1)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">週何日から利用できますか？</span>
                <i className={`ri-arrow-${openFaq === 1 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 1 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  週1日から利用可能です。また、午前のみ・午後のみの通所も可能です。体調や状況に合わせて、柔軟に対応させていただきます。
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(2)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">工賃はどのくらいもらえますか？</span>
                <i className={`ri-arrow-${openFaq === 2 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 2 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  工賃は作業内容や時間によって異なります。詳しくは見学時にご説明させていただきます。
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(3)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">送迎はどこまで対応していますか？</span>
                <i className={`ri-arrow-${openFaq === 3 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 3 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  送迎エリアについては、お住まいの地域によって異なります。お気軽にお問い合わせください。
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(4)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">昼食は必ず注文しないといけませんか？</span>
                <i className={`ri-arrow-${openFaq === 4 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 4 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  昼食の注文は任意です。お弁当を持参していただいても構いません。手作り弁当をご希望の場合は、1食600円でご提供しています。
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(5)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">見学だけでも大丈夫ですか？</span>
                <i className={`ri-arrow-${openFaq === 5 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 5 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  もちろん大丈夫です。利用を前提としない見学や相談のみも大歓迎です。まずはお気軽にお越しください。
                </div>
              )}
            </div>

            <div className="bg-white rounded-2xl shadow-md overflow-hidden">
              <button
                onClick={() => toggleFaq(6)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-orange-50 transition-colors cursor-pointer"
              >
                <span className="font-bold text-gray-900 pr-4">看護師さんにはどんなことを相談できますか？</span>
                <i className={`ri-arrow-${openFaq === 6 ? 'up' : 'down'}-s-line text-amber-500 text-2xl flex-shrink-0`}></i>
              </button>
              {openFaq === 6 && (
                <div className="px-6 pb-5 text-gray-700 leading-relaxed">
                  体調管理、服薬管理、生活リズムの相談など、健康面全般についてご相談いただけます。月2回の定期訪問で、きめ細やかなサポートを行います。
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* お知らせ・ブログ */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-notification-line text-amber-500 mr-3"></i>
              お知らせ・活動報告
            </h2>
            <p className="text-gray-600 text-lg">めーぷるの最新情報をお届けします</p>
          </div>

          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Colorful%20Japanese%20traditional%20dagashi%20candy%20shop%20storefront%20with%20festive%20grand%20opening%20celebration%20decorations%2C%20bright%20welcoming%20atmosphere%2C%20new%20business%20opening%20in%20shopping%20street%2C%20cheerful%20illustration%20art%20style%20with%20warm%20orange%20and%20amber%20tones%2C%20inviting%20small%20business%20exterior%20with%20balloons%20and%20banners%2C%20daytime%20scene&width=400&height=300&seq=news001&orientation=landscape" 
                  alt="オープンのお知らせ" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="bg-amber-400 text-white text-xs px-3 py-1 rounded-full mr-2">お知らせ</span>
                  <span className="text-sm text-gray-600">2025.01.15</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">令和7年、めーぷるがオープンしました</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  小平市の商店街に、就労継続支援B型事業所「めーぷる」がオープンしました。利用者募集中です。
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/883385092dfd56f4edce37e051526201/634330d061d6a7a1eb5386c12586dd69.jpeg" 
                  alt="めだか飼育開始" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="bg-amber-400 text-white text-xs px-3 py-1 rounded-full mr-2">活動報告</span>
                  <span className="text-sm text-gray-600">2025.01.20</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">めだかの飼育を始めました</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  120cm水槽を設置し、様々な種類のめだかの飼育を開始しました。利用者の皆さんと一緒に育てています。
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all hover:-translate-y-1 cursor-pointer">
              <div className="h-48 overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Japanese%20people%20visiting%20and%20touring%20a%20small%20cozy%20welfare%20facility%20and%20candy%20shop%2C%20friendly%20staff%20showing%20visitors%20around%20the%20warm%20interior%20space%2C%20diverse%20group%20of%20adults%20looking%20interested%20and%20comfortable%2C%20welcoming%20atmosphere%2C%20natural%20lighting%2C%20illustration%20art%20style%20with%20soft%20warm%20orange%20amber%20tones%2C%20community%20connection%20scene&width=400&height=300&seq=news003&orientation=landscape" 
                  alt="見学会のお知らせ" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center mb-3">
                  <span className="bg-amber-400 text-white text-xs px-3 py-1 rounded-full mr-2">お知らせ</span>
                  <span className="text-sm text-gray-600">2025.01.25</span>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">見学随時受付中です</h3>
                <p className="text-gray-700 text-sm leading-relaxed">
                  平日随時、見学を受け付けています。お気軽にお問い合わせください。相談のみも大歓迎です。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* お問い合わせ・アクセス */}
      <section id="contact" className="py-20 bg-gradient-to-b from-orange-50 to-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              <i className="ri-mail-line text-amber-500 mr-3"></i>
              お問い合わせ・アクセス
            </h2>
            <p className="text-gray-600 text-lg">お気軽にご連絡ください</p>
          </div>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                <i className="ri-building-line text-amber-500 mr-2"></i>
                事業所情報
              </h3>
              
              <div className="space-y-6">
                <div>
                  <div className="flex items-start mb-2">
                    <i className="ri-map-pin-line text-amber-500 text-xl mr-3 mt-1"></i>
                    <div>
                      <p className="font-bold text-gray-900 mb-1">所在地</p>
                      <p className="text-gray-700">〒187-0035</p>
                      <p className="text-gray-700">東京都小平市小川西町4-28-11</p>
                      <p className="text-gray-700">山下ビル1F</p>
                      <p className="text-sm text-gray-600 mt-1">商店街の中にある駄菓子屋です</p>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex items-start mb-2">
                    <i className="ri-phone-line text-amber-500 text-xl mr-3 mt-1"></i>
                    <div>
                      <p className="font-bold text-gray-900 mb-1">電話番号</p>
                      <a href="tel:042-312-3704" className="text-orange-600 hover:text-orange-700 text-lg cursor-pointer">
                        042-312-3704
                      </a>
                    </div>
                  </div>
                </div>

                <div>
                  <div className="flex items-start mb-2">
                    <i className="ri-time-line text-amber-500 text-xl mr-3 mt-1"></i>
                    <div>
                      <p className="font-bold text-gray-900 mb-1">営業時間</p>
                      <p className="text-gray-700 mb-4">事業所：平日 9:00〜16:00</p>
                      <p className="text-gray-700 mb-2">駄菓子店：</p>
                      <p className="text-gray-700 ml-4">平日 13:00〜18:45</p>
                      <p className="text-gray-700 ml-4">土日祝 10:30〜18:00</p>
                      <p className="text-sm text-gray-600 mt-2">※見学は要予約</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200 space-y-4">
                <a 
                  href="https://forms.gle/qAGBGUHxTvaTkeAW8" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block w-full bg-amber-500 hover:bg-amber-600 text-white text-center px-6 py-4 rounded-xl font-bold transition-colors shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-calendar-check-line mr-2"></i>見学予約フォームはこちら
                </a>
                <a 
                  href="tel:042-312-3704"
                  className="block w-full bg-white hover:bg-gray-50 text-orange-600 text-center px-6 py-4 rounded-xl font-bold transition-colors shadow-md hover:shadow-lg border-2 border-orange-600 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-phone-line mr-2"></i>お電話でのお問い合わせ
                </a>
              </div>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-md">
              <h3 className="text-2xl font-bold text-gray-900 mb-6">
                <i className="ri-map-line text-amber-500 mr-2"></i>
                アクセス
              </h3>
              
              <div className="aspect-video bg-gray-100 rounded-xl overflow-hidden mb-6">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.8!2d139.4776!3d35.7283!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6018e6e8e8e8e8e8%3A0x8e8e8e8e8e8e8e8e!2z5p2x5Lqs6YO95bCP5bmz5biC5bCP5bed6KW_55S677yU5LiB55uu77yS77yY4oiS77yR77yR!5e0!3m2!1sja!2sjp!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="めーぷる所在地"
                ></iframe>
              </div>

              <div className="bg-orange-50 p-6 rounded-xl">
                <p className="text-gray-700 leading-relaxed mb-4">
                  <i className="ri-train-line text-amber-500 mr-2"></i>
                  <strong>最寄り駅：</strong>小平駅より徒歩圏内
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <i className="ri-store-line text-amber-500 mr-2"></i>
                  商店街の中にある駄菓子屋です。地域の皆様に親しまれる場所を目指しています。
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gradient-to-br from-orange-700 to-amber-800 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-3 gap-8 mb-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-orange-400 to-red-500 rounded-full flex items-center justify-center">
                  <i className="ri-leaf-fill text-white text-2xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold">めーぷる</div>
                  <div className="text-sm text-amber-200">就労継続支援B型事業所</div>
                </div>
              </div>
              <p className="text-orange-100 text-sm leading-relaxed">
                小平市の商店街で、一人ひとりのペースを大切にした就労支援を行っています。
              </p>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4 text-amber-300">クイックリンク</h4>
              <ul className="space-y-2 text-sm">
                <li>
                  <button onClick={() => scrollToSection('concept')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>理念
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('features')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>特徴
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('work')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>作業内容
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('voices')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>利用者の声
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('staff')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>スタッフ
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('usage')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>利用について
                  </button>
                </li>
                <li>
                  <button onClick={() => scrollToSection('faq')} className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    <i className="ri-arrow-right-s-line mr-1"></i>FAQ
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4 text-amber-300">お問い合わせ</h4>
              <ul className="space-y-3 text-sm">
                <li className="flex items-start">
                  <i className="ri-phone-line mr-2 mt-1"></i>
                  <a href="tel:042-312-3704" className="text-orange-100 hover:text-white transition-colors cursor-pointer">
                    042-312-3704
                  </a>
                </li>
                <li className="flex items-start">
                  <i className="ri-map-pin-line mr-2 mt-1"></i>
                  <div className="text-orange-100">
                    <div>東京都小平市小川西町4-28-11</div>
                    <div>山下ビル1F</div>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-orange-600 pt-8 text-center">
            <p className="text-orange-100 text-sm">
              &copy; 2025 就労継続支援B型事業所 めーぷる. All rights reserved. | 
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-amber-300 hover:text-white ml-2 cursor-pointer">
                Website Builder
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}